import { render, staticRenderFns } from "./UserProgress.vue?vue&type=template&id=2889e81c&"
import script from "./UserProgress.vue?vue&type=script&lang=js&"
export * from "./UserProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports